import {FbFormObject} from '../class/fb_form_object';

export class RaceTrack extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'track_name', label: 'Name', visible: true, noclick: false, disable_ripple: true},
            {id: 'operator', label: 'Operator', visible: true, noclick: false, disable_ripple: true},
            {id: 'description', label: 'Description', visible: true, noclick: false, disable_ripple: true},
            {id: 'is_arena_commander', label: 'Arena Commander', visible: true, noclick: false, disable_ripple: true},
            {id: 'sort', label: 'Sort', visible: true, noclick: false, disable_ripple: true},
            {id: 'image', label: 'Image', visible: true, type: 'template', template_row: this.templates['upload_tpl'],
                noclick: false, disable_ripple: true}
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'Track',
                class: 'card card-1 padding single-column',
                field_class: '',
                fields: [
                    {
                        type: 'text',
                        name: 'track_name',
                        rules: [
                            {rule: 'required'}
                        ]
                    },
                    {
                        type: 'text',
                        name: 'operator',
                    },
                    {
                        type: 'textarea',
                        name: 'description'
                    },
                    {
                        type: 'checkbox',
                        name: 'is_arena_commander',
                    },
                    {
                        type: 'number',
                        name: 'sort',
                    },
                    {
                        type: 'template',
                        template: this.templates['upload_tpl'],
                        name: 'image',
                        disabled: true,
                        no_input: false
                    }
                ]
            }
        ];
        super.setEditFields();
    }

    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.stores['race_tracks'] = this.storeService.getStore('race_tracks');

            this.main_store = this.stores['race_tracks'];

            const stores = [];
            stores.push(this.stores['race_tracks'].loadStore(this.filter));

            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        return {
            data: {
                track_name: '',
                description: '',
                file_id: 0
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        // call super
        super.setSelectboxes();
    }

}
